import { Stack, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { getAllIncome } from "../../api";
import { useSnackbar } from "notistack";
import LoadingContent from "../common/LoadingContent";
import IncomeCard from "../cards/IncomeCard";

export const Income = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchIncomes = () => {
    setLoading(true);
    getAllIncome({
      filter: {
        status: ["PENDING", "ACTIVE"],
      },
    })
      .then((res) => setIncomes(res.data.rows))
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchIncomes();
  }, []);

  return (
    <>
      <LoadingContent loading={loading}>
        <Stack>
          {incomes.length > 0 ? (
            incomes.map((expense) => (
              <IncomeCard
                key={expense.id}
                data={expense}
                enqueueSnackbar={enqueueSnackbar}
                approve
                reset={fetchIncomes}
              />
            ))
          ) : (
            <Typography sx={{ textAlign: "center", py: 5 }}>
              No income found!
            </Typography>
          )}
        </Stack>
      </LoadingContent>
    </>
  );
};

export default Income;
